import { RouteLocationAsRelativeGeneric } from 'vue-router';

export function getCodeLink(codeSetName: string, identity: string): string {
    return `/Library/CodeSet/${codeSetName}/Code/${encodeURIComponent(identity)}`;
}

export function getCodeLinkByB64Id(b64Id: string): string {
    return `/Library/Code/${b64Id}`;
}

export function getCodeNetworkLink(dbId: number): RouteLocationAsRelativeGeneric {
    return { name: 'CodeNetwork', params: { dbId: dbId } };
}

export function getLibraryListLink(tags: string[]): string {
    return `/Library?TagFilter=${encodeURIComponent(JSON.stringify(tags))}`;
}

export function getLibraryLink(libraryName: string): RouteLocationAsRelativeGeneric {
    return { name: 'Library', params: { libraryName: libraryName } };
}

export function getLibraryNetworkLink(): RouteLocationAsRelativeGeneric {
    return { name: 'LibraryNetwork' };
}

export function getLibraryChangelogLink(): RouteLocationAsRelativeGeneric {
    return { name: 'LibraryChangelog' };
}

export function getCodeSetLink(codeSetName: string): string {
    return `/Library/CodeSet/${codeSetName}`;
}

export function getReleaseLink(releaseId: number): RouteLocationAsRelativeGeneric {
    return { name: 'ReleaseById', params: { release: releaseId } };
}

export function getMyReleaseArchiveLink(): RouteLocationAsRelativeGeneric {
    return { name: 'MyReleasesArchive' };
}

export function getMyReleaseLink(): RouteLocationAsRelativeGeneric {
    return { name: 'MyReleases' };
}

export function getApplicationLink(applicationName: string): RouteLocationAsRelativeGeneric {
    const uriEncodedApplicationName = encodeURIComponent(applicationName);
    return { name: 'ApplicationDetails', params: { appName: uriEncodedApplicationName } };
}

export function getAccessGroupLink(groupId: number): RouteLocationAsRelativeGeneric {
    return { name: 'AccessGroupDetails', params: { groupId: groupId } };
}

export function getSubscriptionLink(applicationName: string, subscriptionId: number): RouteLocationAsRelativeGeneric {
    return { name: 'SubscriptionDetails', params: { appName: applicationName, subscriptionId: subscriptionId } };
}

export function getClientApplicationDetailsLink(userId: string): RouteLocationAsRelativeGeneric {
    return { name: 'ClientApplicationDetails', params: { userId } };
}

export function getCorrelatedEventDetailsLink(correlationId: string): RouteLocationAsRelativeGeneric {
    return { name: 'CorrelatedEventDetails', params: { correlationId } };
}

export function getQuantityLink(quantityIdentity: string): RouteLocationAsRelativeGeneric {
    return { name: 'Quantity', params: { quantityIdentity: quantityIdentity } };
}

export function getReleaseLogLink({ libraryName = '', applicationName = '', codeSetName = '', releaseId = '' }): RouteLocationAsRelativeGeneric {
    const encodedLib = encodeURIComponent(libraryName);
    const encodedApp = encodeURIComponent(applicationName);
    const encodedCodeSet = encodeURIComponent(codeSetName);
    const encodedReleaseId = encodeURIComponent(releaseId);

    return { name: 'Log', query: {
        libraryName: encodedLib,
        applicationName: encodedApp,
        codeSetName: encodedCodeSet,
        releaseId: encodedReleaseId
    } };
}

export function explorerLinkLibrary(lib: string): RouteLocationAsRelativeGeneric {
    return { name: 'LibraryNetworkForLibrary', params: { library: lib } };
}

export function getWebhookLink(hookId: number): string {
    return `/Config/Webhooks?hookId=${hookId}`;
}

export function getSqlEditorLink(): RouteLocationAsRelativeGeneric {
    return { name: 'SqlEditor' };
}

export function getSqlEditorLinkByLibrary(libraryName: string): RouteLocationAsRelativeGeneric {
    if (libraryName) {
        return { name: 'SqlEditorByLibrary', params: { libraryName } };
    } else {
        return getSqlEditorLink();
    }
}

export function getSqlEditorLinkBySavedQuery(guid: string): RouteLocationAsRelativeGeneric {
    if (guid) {
        return { name: 'SqlEditorBySavedQuery', params: { guid } };
    } else {
        return getSqlEditorLink();
    }
}

export function getSqlResultLink(query: string, title?: string, pageSize?: number): RouteLocationAsRelativeGeneric {
    return {
        name: 'SqlResult',
        query: {
            query: query,
            title: title,
            pageSize: pageSize
        }
    };
}

export function getQueryReportLinkBySavedQuery(guid: string, title?: string): RouteLocationAsRelativeGeneric {
    if (guid) {
        if (title) {
            return {
                name: 'QueryReportByGuid',
                params: { guid },
                query: { title }
            };
        }

        return { name: 'QueryReportByGuid', params: { guid } };
    } else {
        return { name: 'QueryReportMain' };
    }
}

export function getTRDocumentListLink(): RouteLocationAsRelativeGeneric {
    return { name: 'TRDocumentList' };
}

export function getTRDocumentDetailsLink(trDocumentIdentity: string): RouteLocationAsRelativeGeneric {
    return {
        name: 'TRDocumentDetails',
        params: {
            trDocumentIdentity: trDocumentIdentity
        }
    };
}

export type TRRevisionContentEditorProps = {
    trDocumentIdentity?: string;
    trRevisionIdentity?: string;
};

export function getTRRevisionContentEditorLink(params: TRRevisionContentEditorProps): RouteLocationAsRelativeGeneric {
    return {
        name: 'TRRevisionContentEditor',
        params
    };
}

export function getTRRevisionQueryTemplateListLink(trDocumentIdentity: string): RouteLocationAsRelativeGeneric {
    return {
        name: 'TRRevisionQueryTemplateList',
        params: {
            trDocumentIdentity
        }
    };
}

export function getDocumentationTopicLink(topicIdentity: string): RouteLocationAsRelativeGeneric {
    return {
        name: 'DocumentationTopic',
        params: {
            identity: topicIdentity
        }
    };
}

export function getDocumentationDocumentLink(documentIdentity: string): RouteLocationAsRelativeGeneric {
    return {
        name: 'DocumentationDocument',
        params: {
            identity: documentIdentity
        }
    };
}
